import { put, call, takeLatest } from 'redux-saga/effects';

import * as actionCreators from '../redux/actions';
import * as actionAlbum from '../../Album/redux/actions';
import * as actionVideoDetail from '../../Video/redux/actions';
import * as actionTypes from '../redux/actions/type';
import API, { ROUTES } from "../../../commons/api/api";
import {removeAllStorage} from "../../../utils/helpers";

function* logOut(action) {
  try {
    const response = yield call(() =>
      API.post(ROUTES.API_LOGOUT)
    );
    if (response.status == 200) {
      yield put(actionAlbum.resetAlbum());
      yield put(actionCreators.logOutSuccess(response));
      yield put(actionVideoDetail.resetVideoRender())
    }else{
      yield put(actionCreators.logOutFaild());
    }
    
  } catch (error) {
    
  }
}

function* logOutSaga() {
  yield takeLatest(actionTypes.LOGOUT_REQUEST, logOut);
}

export default logOutSaga;
